import { Form, Select, Tooltip } from 'antd';
import FormMessage from 'components/Form/FormMessage';
import React, { useState } from 'react';

const FormSelectSearch = ({
  name,
  required,
  messageRequired,
  placeholder,
  onChange,
  data,
  isLoading,
  height,
  allowClear = true,
  maxLength = 256,
}) => {
  const [searchValue, setSearchValue] = useState('');

  const handleSearch = (value) => {
    if (value.length <= maxLength) {
      setSearchValue(value);
    }
  };

  return (
    <Form.Item
      name={name}
      rules={[
        {
          required: required,
          message: (
            <FormMessage text1={messageRequired} marginBottom={'12px'} />
          ),
        },
      ]}
    >
      <Select
        onSearch={handleSearch}
        showSearch
        allowClear={allowClear}
        style={{ height: height }}
        placeholder={placeholder}
        optionFilterProp="label"
        onChange={onChange}
        options={data}
        loading={isLoading}
        searchValue={searchValue}
      />
    </Form.Item>
  );
};

export default FormSelectSearch;
